import React from "react";
import { useLocation, Link } from "react-router-dom";

function NoPermissionPage() {
  const query = new URLSearchParams(useLocation().search);
  const reason = query.get("reason");


  const getReasonMessage = () => {
    switch (reason) {
      case "role":
        return "Your current role does not grant access to this operation. Please switch to a different group.";
      default:
        return "You don’t have permission to access this resource.";
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-purple-100 to-pink-100 px-4 py-8">
      <div className="bg-white shadow-2xl rounded-3xl p-8 sm:p-12 max-w-md w-full text-center transform transition-all duration-300 hover:scale-105 animate-fade-in">
        
        <h1 className="text-4xl sm:text-5xl font-extrabold text-red-600 mb-6 tracking-tight">
          Access Denied
        </h1>


        <p className="text-gray-700 text-lg sm:text-xl mb-4 leading-relaxed">
          {getReasonMessage()}
        </p>


        <p className="text-gray-600 text-base sm:text-lg mb-6">
          Please contact your{" "}
          <span className="font-semibold text-blue-600">Admin Team</span> for assistance.
        </p>
        <Link
          to="/"
          className="inline-block px-6 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold rounded-full shadow-lg hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 transform hover:-translate-y-1"
        >
          Go Home
        </Link>
      </div>
    </div>
  );
}

export default NoPermissionPage;
